import clsx from 'clsx';
import React from 'react';

const InlineAlert = ({
  children,
  size = 'sm',
  as: AsComponent = 'div',
  className,
  href,
  ...props
}) => {
  return (
    <AsComponent
      {...props}
      href={href}
      className={clsx(`bg-chocolate-50 rounded text-gray-900 flex items-center`, className, {
        'p-4 gap-x-4 text-sm': size === 'sm',
        'p-6 gap-x-6': size === 'lg',
        'hover:bg-gray-100 transition-colors': !!href,
      })}
    >
      {children}
    </AsComponent>
  );
};

const Visual = ({ children }) => <div className="inline-flex items-center">{children}</div>;

InlineAlert.Visual = Visual;

const Message = ({ className, children }) => (
  <div className={clsx('font-normal', className)}>{children}</div>
);

InlineAlert.Message = Message;

export default InlineAlert;
